import axios from './axios'

const instance = axios()
const contentType = { 'Content-Type': 'application/x-www-form-urlencoded' }
// let fileType = {'Content-Type': 'multipart/form-data'}
export default {
  get(url, params) {
    const options = {}
    if (params) {
      options.params = params
    }
    options.headers = contentType
    return instance.get(url, options)
  },
  post(url, params, headers) {
    const options = {}
    options.headers = contentType
    if (headers) {
      options.headers = headers
    }
    return instance.post(url, params, options)
  },
  put(url, params, headers) {
    const options = {}
    if (headers) {
      options.headers = headers
    }
    return instance.put(url, params, options)
  },
  delete(url, params, headers) {
    const options = {}
    if (params) {
      options.params = params
    }
    if (headers) {
      options.headers = headers
    }
    return instance.delete(url, options)
  }
}
